module.exports = __webpack_public_path__ + "img/brand-cases2.8e5e27ab.png";